/**
 * 배열 유틸리티 함수
 */

/**
 * 두 문자열 배열이 동일한 요소를 가지고 있는지 비교 (순서 무관)
 *
 * @description
 * Set을 사용하여 O(n) 시간복잡도로 두 배열의 요소가 동일한지 비교합니다.
 * 순서는 무시하며, 중복 요소는 하나로 취급됩니다.
 *
 * @param a - 첫 번째 배열
 * @param b - 두 번째 배열
 * @returns 두 배열이 동일한 요소를 가지고 있으면 true
 *
 * @example
 * areArraysEqual(['a', 'b'], ['b', 'a']) // true
 * areArraysEqual(['a', 'b'], ['a', 'b', 'c']) // false
 * areArraysEqual([], []) // true
 */
export const areArraysEqual = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  const setA = new Set(a);
  return b.every((item) => setA.has(item));
};
